module.exports = __webpack_public_path__ + "img/city (8).01ac80f8.png";